import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { ScrollArea } from '@/components/ui/scroll-area';
import { DynamicIcon } from '@/components/ui/dynamic-icon';
import { cn } from '@/lib/utils';

const EXPENSE_ICONS = [
  'Fuel',
  'Wrench',
  'AlertTriangle',
  'CircleDot',
  'Route',
  'ParkingCircle',
  'ShieldAlert',
  'Shield',
  'FileText',
  'FileCheck',
  'Droplets',
  'Files',
  'Package',
  'Radar',
  'MoreHorizontal',
  'DollarSign',
  'CreditCard',
  'Wallet',
  'Receipt',
  'Calculator',
  'TrendingUp',
  'TrendingDown',
  'BarChart',
  'PieChart',
  'ShoppingCart',
  'Tag',
  'Percent',
  'Banknote',
  'Coins',
  'BadgeDollarSign',
  'CircleDollarSign',
];

interface IconPickerProps {
  value: string;
  onChange: (icon: string) => void;
  className?: string;
}

export function IconPicker({ value, onChange, className }: IconPickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn('w-full justify-start gap-2', className)}
        >
          <DynamicIcon name={value} size={20} />
          <span>{value}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <ScrollArea className="h-64">
          <div className="grid grid-cols-6 gap-2 p-2">
            {EXPENSE_ICONS.map((icon) => (
              <button
                key={icon}
                className={cn(
                  'flex items-center justify-center w-12 h-12 rounded border-2 transition-all hover:scale-110 hover:bg-accent',
                  value === icon ? 'border-primary bg-accent' : 'border-border'
                )}
                onClick={() => onChange(icon)}
                title={icon}
              >
                <DynamicIcon name={icon} size={24} />
              </button>
            ))}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
}
